export const VALIDATE_IBAN = gql`
    mutation validateIBAN($IBAN: String!) {
        validateIBAN(IBAN: $IBAN)
    }
`;
export const VALIDATE_BIC = gql`
    mutation validateBIC($BIC: String!, $IBAN: String) {
        validateBIC(BIC: $BIC, IBAN: $IBAN)
    }
`;

export const VALIDATE_UK_BANK = gql`
    mutation validateUKBank($sortCode: String!, $accountNumber: String!) {
        validateUKBank(sortCode: $sortCode, accountNumber: $accountNumber) {
            IBAN
            ContactAddressLine1
            ContactAddressLine2
            ContactPostTown
            ContactPostcode
            ContactPhone
            StatusInformation
            Bank
            Branch
        }
    }
`;
